import JourneySearchTables from './JourneySearchTables';

export default JourneySearchTables;
